/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Lots_Search_PhInputs */

const vi_aml_lots_search_ph = /** @type {(inputs: Aml_Lots_Search_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm theo mã lô / tên vật tư`)
};

/**

* @param {Aml_Lots_Search_PhInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_lots_search_ph = /** @type {((inputs?: Aml_Lots_Search_PhInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Lots_Search_PhInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_lots_search_ph(inputs)
});